import { jsx as _jsx } from "react/jsx-runtime";
export function Postatus(param) {
    var status = param.status;
    return status == 1 ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "#747474",
            backgroundColor: "#F4F4F4",
            borderRadius: "20px"
        },
        children: "แบบร่าง"
    }) : status == 2 ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "#FDB428",
            backgroundColor: "rgba(255, 246, 229, 1)",
            borderRadius: "20px"
        },
        children: "รออนุมัติ"
    }) : status == 3 ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "#FDB428",
            backgroundColor: "#FFF6E5",
            borderRadius: "20px"
        },
        children: "อนุมัติ"
    }) : status == 4 ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "#FFFFFF",
            backgroundColor: "#3FA5FF",
            borderRadius: "20px"
        },
        children: "รอรับสินค้า"
    }) : status == 5 ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "#FF731D",
            backgroundColor: "rgba(255, 115, 29, 0.15)",
            borderRadius: "20px"
        },
        children: "รับสินค้าบางส่วน"
    }) : status == 6 ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "rgba(114, 225, 40, 0.87)",
            backgroundColor: "#EEFBE5",
            borderRadius: "20px"
        },
        children: "เสร็จสิ้น"
    }) : status == 7 ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "rgba(249, 80, 87, 1)",
            backgroundColor: "rgba(255, 0, 0, 0.15)",
            borderRadius: "20px"
        },
        children: "ยกเลิก"
    }) : status == "overdue" ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "#FF0000",
            backgroundColor: "transparent",
            borderRadius: "20px"
        },
        children: "เกินกำหนด"
    }) : status == "force-success" ? /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 mx-auto d-inline-block",
        style: {
            color: "#FF0000",
            backgroundColor: "transparent",
            borderRadius: "20px"
        },
        children: "แบบมีเงื่อนไข"
    }) : "";
}
